import { render, staticRenderFns } from "./notFound.vue?vue&type=template&id=ffea3086&scoped=true"
import script from "./notFound.vue?vue&type=script&lang=js"
export * from "./notFound.vue?vue&type=script&lang=js"
import style0 from "./notFound.vue?vue&type=style&index=0&id=ffea3086&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffea3086",
  null
  
)

export default component.exports